<div class="top-nav">
    <div class="row">
        <div class="log-col">
            <mat-icon
                [inline]="true"
                class="logo-img"
                svgIcon="hub_dxc_logo"
                (click)="navigateToHomePage()"
                title="{{consts.SECTION_DXC_LOGO_HOVER}}"
            >
            </mat-icon>
        </div>
		<div class="col">
		    <div class="favorites">
		        <button
                    mat-raised
                    [matMenuTriggerFor]="favoritesMenu"
                >
		            {{consts.SECTION_FAVORITES}}
                    <mat-icon svgIcon="hub_down_arrow"></mat-icon>
		        </button>
		    </div>
		    <mat-menu
                #favoritesMenu
                class="fav"
                xPosition="before"
                [overlapTrigger]="false"
                panelClass='CustomClass'
            >
                <app-favorites (newItemEvent)="openFav()"></app-favorites>
            </mat-menu>
		</div>
        <div class="col text-end">
            <app-world-clock></app-world-clock>
            <button
                mat-flat-button
                class="dxc-purple notify-button"
                (click)="toggleNotifications()"
            >
                <div class="bell-icon-wrapper">
                    <mat-icon
                        svgIcon="hub_bell"
                        class="bell-icon"
                    >
                    </mat-icon>
                    <div *ngIf="(notifCount$ | async) > 0" class="notif-indicator"></div>
                </div>

                <ng-container *ngIf="notifCount$ | async as notifCount" class="notif-indicator-count">
                    {{notifCount > consts.MAX_NOTIF_COUNT ? consts.MAX_NOTIF_COUNT + '+' : notifCount}}
                </ng-container>
            </button>

            <button
                mat-flat-button
                class="dxc-purple profile-pic"
                [matMenuTriggerFor]="profileMenu"
                #menuTrigger="matMenuTrigger"
                (mouseenter)="openProfileMenu()"
                (mouseleave)="closeProfileMenu()"
            >
                <mgt-person class="mgt-custom-avatar" person-query="me"></mgt-person>
            </button>
            <mat-menu
                #profileMenu="matMenu"
                class="user-profile-menu"
                xPosition="before"
                yPosition="below"
                [hasBackdrop]="false"
                [overlapTrigger]="false"
            >
                <div
                    class="profile-dropdown"
                    (mouseenter)="openProfileMenu()"
                    (mouseleave)="closeProfileMenu()"
                >
                    <div class="profile-details">
                        <div class="mgt-img-container">
                            <mgt-person
                                class="mgt-profile-avatar"
                                person-query="me"
                            >
                            </mgt-person>
                        </div>
                        <span *ngIf="preferredName$ | async as preferredName" class="preferred-name center">
                            {{preferredName}}
                        </span>
                    </div>
                    <button
                        id="ViewWorkProfile"
                        mat-menu-item
                        (click)="showUserProfile()"
                        class="view-profile"
                    >
                        {{consts.SECTION_WORK_PROFILE}}
                    </button>
                    <div class="menu-item">
                        <button (click)="navigateToHomePage()">
                            <mat-icon svgIcon="hub_home"></mat-icon>
                            {{consts.PROFILE_DROPDOWN_HOME}}
                        </button>
                        <!-- TODO: Enable settings in the menu when the settings page is ready -->
                        <!-- <button>
                            <mat-icon svgIcon="hub_perm_identity"></mat-icon>
                            {{consts.PROFILE_DROPDOWN_SETTINGS}}
                        </button> -->
                        <button (click)="openFav()">
                            <mat-icon svgIcon="hub_star_border"></mat-icon>
                            {{consts.PROFILE_DROPDOWN_FAV}}
                        </button>
                        <!-- For Announcements-->
                        <ng-container *ngIf="(!environmentType$)">
                            <button class="announcement-menulink" (click)="openLink(consts.ADD_ADMIN_LINK)">
                                <mat-icon svgIcon="hub_perm_identity"></mat-icon>
                                {{consts.PROFILE_DROPDOWN_ADMIN}}
                            </button>
                        </ng-container>
                        <!-- For Announcements dialog-->
                        <ng-container *ngIf="userPermission">
                            <button class="announcement-menulink" (click)="openAnnouncementsDialog()">
                                <mat-icon svgIcon="hub_announcements_horn"></mat-icon>
                                {{consts.PROFILE_DROPDOWN_ANNOUNCEMENTS}}
                            </button>
                        </ng-container>
                        <button (click)="openLink(consts.HELP_LINK)">
                            <mat-icon svgIcon="hub_help"></mat-icon>
                            {{consts.HELP_LABEL}}
                        </button>
                        <button (click)="logout()">
                            <mat-icon svgIcon="hub_logout"></mat-icon>
                            {{consts.LOGOUT_LABEL}}
                        </button>
                    </div>
                </div>
            </mat-menu>
        </div>
    </div>
</div>
